export default __webpack_public_path__ + "static/media/conversions-chart.5c3a5171.png";